import React, { useRef, useState } from "react";
import {
  Pagination,
  Paper,
  Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid,
  Chip,
} from "@mui/material";
import {
  DirectionsCar,
  MonetizationOn,
  Straighten,
  Scale,
} from "@mui/icons-material";
// import axios from "axios";
import { FilterAlt } from "@mui/icons-material";
import { useEffect } from "react";
import { CustomIconButton } from "../../shared/CustomIconButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Popup from "reactjs-popup";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";

import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import { toast } from "react-toastify";
import axiosInstance, { baseUrl } from "../../config/axios";
import Reason from "./Reason";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const OrderManagement = () => {
  const { state } = useLocation();
  const [orderData, setOrderData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDates, setToDates] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const hideBox = useRef();
  const box1 = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const storeIds = localStorage.getItem("store_id");
  const superuserId = localStorage.getItem("is_superuser");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [page, setPage] = React.useState(1);
  const [orderChangeId, setOrderChangeId] = useState("");
  // Drawer start
  const [orderItem, setOrderItem] = useState([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  // Drawer end
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [pricingLoading, setPricingLoading] = useState(false);

  const OrderListData = () => {
    axiosInstance
      .get(
        `api/admin/multivendor-super-admin-sales-order-list/?store_id=${storeIds}&from_date=${fromDate}&to_date=${toDates}&order_status=${
          state?.status ? state?.status : selectStatus
        }&search=${searchQuery}&page=${page}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setOrderData(response?.data?.data);
        setCurrentPage(response.data.current_page);
        setTotalPage(response.data.total_pages);
      })
      .catch((error) => {
        console.log(error);
        console.log("error why==>");
      });
  };

  const handleChange = (id) => {
    console.log(id, "ID");
    axiosInstance
      .post(
        `sales-order-assign-order-to-another-store/`,
        {
          order_id: id,
          assign_order_to_another_store_id: 98,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        },
      )
      .then((response) => {
        setOrderData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const StoreList = () => {
  //   axios
  //     .post(
  //       `${baseUrl}api/admin/multivendor-show-store-list/`,
  //       {},
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setStore(response?.data?.vendor_store_list);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   StoreList();
  // }, []);

  useEffect(() => {
    OrderListData();
  }, [fromDate, toDates, selectStatus, page, searchQuery, page]);

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const closeModal = () => {
    box1.current.style.display = "none";
  };

  const arr1 = ["Pending", "Accepted", "Rejected", "Delivered"];

  const ORDERITEMSTATUS = [
    "Pending",
    "Accepted",
    "Packing",
    "Shipped",
    "Delivered",
    "Rejected",
    "Cancelled",
    "Returned",
    "Replacement",
    "Refunded",
  ];

  const CANCELSTATUS = ["Pending", "Accepted", "Processing", "Refunded"];

  const RETURNSTATUS = [
    "Pending",
    "Accepted",
    "Pickup Scheduled",
    "Picked Up",
    "Processing",
    "Refunded",
  ];
  const REPLACEMENTSTATUS = [
    "Pending",
    "Accepted",
    "Pickup Scheduled",
    "Picked Up",
    "Processing",
    "Shipped",
    "Delivered",
    "Completed",
  ];

  const STATUS_COLORS = {
    Pending: "#FFA500",
    Accepted: "#007BFF",
    Packing: "#6C757D",
    Shipped: "#17A2B8",
    Delivered: "#28A745",
    Rejected: "#DC3545",
    Cancelled: "#343A40",
    Returned: "#FFC107",
    Replacement: "#6610F2",
    Refunded: "#20C997",

    Processing: "#FD7E14",

    "Pickup Scheduled": "#03A9F4",
    "Picked Up": "#009688",

    "Pickup Scheduled": "#03A9F4",
    "Picked Up": "#009688",
    Processing: "#FD7E14",
    Shipped: "#17A2B8",
    Delivered: "#28A745",
    Completed: "#6F42C1",
  };

  const sideBarDataList = (row) => {
    console.log("orderID", row);
    setOrderChangeId(row);
    // event.preventDefault();
    toggleDrawer();
    axiosInstance
      .post(
        `api/admin/multivendor-super-admin-sales-orderitem-list/`,
        { order_id: row },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setOrderItem(response?.data?.data);
        console.log("Item list data", response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SyncData = (row) => {
    axiosInstance
      .post(
        `api/admin/sync-order-to-shiprocket/`,
        { order_id: row },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        OrderListData();

        // console.log("Item list data", response?.data);
        toast.success(response?.data?.msg);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const PorterSyncData = (row) => {
    axiosInstance
      .post(
        `api/admin/sync-order-to-porter/`,
        { order_id: row },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        OrderListData();

        // console.log("Item list data", response?.data);
        toast.success(response?.data?.msg);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUpdate = (value, id) => {
    const sendStatus = {
      item_code: id,
      change_order_status: value,
    };

    axiosInstance
      .post(
        `api/admin/multivendor-super-admin-sales-order-items-status-updates/`,
        sendStatus,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((res) => {
        toast.success(res.data?.message);
        toggleDrawer();
        sideBarDataList(orderChangeId);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange1 = (event, value) => {
    setPage(value);
  };

  const ViewPricing = (row) => {
    setPricingLoading(true);

    setPricingModalOpen(true);
    axiosInstance
      .post(`api/admin/get-quotations-for-porter-api-of-bhaaraterp/`, row, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        if (response?.data?.response_code === 200) {
          setVehicleData(response?.data?.data?.vehicles);
        } else {
          toast.warn(response?.data?.message);
        }
        setPricingLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setPricingLoading(false);
      });
  };

  const CancelPorterOrder = (row) => {
    axiosInstance
      .post(
        `api/admin/porter-order-details-or-cancel-api/`,
        { order_id: row },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        if (response?.data?.response_code === 200) {
          OrderListData();

          toast.success(response?.data?.msg);
        } else {
          toast.warn(response?.data?.msg);
        }
        setPricingLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setPricingLoading(false);
      });
  };

  const cellSx = {
    borderRight: "1px solid #D0D0D0",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "11px",
    padding: "3px 6px",
    textAlign: "center",
    lineHeight: 1.2,
  };

  const headSx = {
    ...cellSx,
    fontWeight: 700,
    color: "#1f2937",
    whiteSpace: "nowrap",
  };

  const btnSx = {
    fontSize: 11,
    py: 0.25,
    px: 1,
    minWidth: 0,
    lineHeight: 1.4,
    textTransform: "none",
  };

  const statusChipStyle = (color) => ({
    backgroundColor: color || "#000",
    color: "#fff",
    padding: "1px 6px",
    borderRadius: "4px",
    fontSize: "10px",
    whiteSpace: "nowrap",
  });

  return (
    <div className="!float-right px-2" style={{ width: "100%" }}>
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font-bold">Order Management List</p>
        </div>
        <div className="p-2 pt-5">
          <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            className="bla bla bla overflow-auto"
            size="650px"
          >
            <div className="w-[96] m-5 ">
              <div className="text-gray-900 text-lg font-bold">
                Order Details
              </div>
              <div className="text-black text-sm pt-2">Delivery Address</div>
              <div className="border w-[600px] border-gray-500 rounded-sm p-2 my-3">
                <div className="px-3 text-gray-900">
                  {orderItem[0]?.order?.customer_first_name}{" "}
                  {orderItem[0]?.order?.customer_last_name}
                </div>
                <div className="text-[12px] text-gray-500 px-3">
                  {orderItem[0]?.order?.customer_address},
                  {orderItem[0]?.order?.customer_address_2},{" "}
                  {orderItem[0]?.order?.customer_pincode},{" "}
                  {orderItem[0]?.order?.customer_state},{" "}
                  {orderItem[0]?.order?.customer_country} sdfsdfs
                </div>
              </div>
              <TableContainer component={Paper}>
                <Table aria-label="simple table" className="!text-[12px]">
                  <TableHead>
                    <TableRow className="!bg-gray-300 !font-bold">
                      <TableCell>Image</TableCell>
                      <TableCell align="center">
                        <div className="!w-40 center">items Name</div>
                      </TableCell>
                      <TableCell align="center">Quantity</TableCell>
                      <TableCell align="center">
                        <div className="!w-28 center">Price </div>
                      </TableCell>
                      <TableCell align="center">
                        <div className="w-28">Order status</div>
                      </TableCell>
                      <TableCell align="center">Update</TableCell>

                      <TableCell align="center">
                        Return Replacement Reason
                      </TableCell>
                      <TableCell align="center">
                        <div className="w-28">Item Code</div>
                      </TableCell>
                      <TableCell align="center">
                        <div className="w-28">Proceed Payment :</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderItem?.map((row) => (
                      <TableRow
                        key={row?.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <img src={row?.image} className="h-12 w-10" />
                        </TableCell>

                        <TableCell
                          sx={{
                            width: 300, // control column width
                            maxWidth: 300,
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "Poppins",
                            whiteSpace: "normal", // allow wrap
                            wordBreak: "break-word", // break long words
                          }}
                          className="!text-center !text-[12px]"
                        >
                          <p className="text-[10px] whitespace-normal break-words">
                            {row?.product_name}
                          </p>
                        </TableCell>
                        {/* <TableCell align="center">
                          {row?.product_name}
                        </TableCell> */}
                        <TableCell align="center">{row?.quantity}</TableCell>
                        <TableCell align="center">
                          ₹ {row?.variant_price}
                        </TableCell>
                        <TableCell align="center">
                          <span
                            key={row?.order_item_status}
                            style={{
                              backgroundColor:
                                STATUS_COLORS[row?.order_item_status] || "#000",
                              color: "#fff",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              marginRight: "5px",
                              fontSize: "14px",
                            }}
                          >
                            {row?.order_item_status}
                          </span>

                          {/* <span>
                            {row?.order_item_status === "Delivered" ? (
                              <Button
                                className="!bg-green-400 !text-[8px] !text-white"
                                size="small"
                              >
                                Delivered
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Pending" ? (
                              <Button
                                className="!bg-pink-500 !text-[8px] !text-white"
                                size="small"
                              >
                                Pending
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Order Placed" ? (
                              <Button
                                className="!bg-yellow-400 !text-[8px] !text-white"
                                size="small"
                              >
                                Order Placed
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Shipped" ? (
                              <Button
                                className="!bg-purple-400 !text-[8px] !text-white"
                                size="small"
                              >
                                Shipped
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Drafts" ? (
                              <Button
                                className="!bg-red-600 !text-[8px] !text-white"
                                size="small"
                              >
                                Drafts
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Accepted" ? (
                              <Button
                                className="!bg-sky-300 !text-[8px] !text-white"
                                size="small"
                              >
                                Accepted
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Rejected" ? (
                              <Button
                                className="!bg-red-700 !text-[8px] !text-white"
                                size="small"
                              >
                                Rejected
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Cancelled" ? (
                              <Button
                                className="!bg-red-700 !text-[8px] !text-white"
                                size="small"
                              >
                                Cancelled
                              </Button>
                            ) : null}
                          </span>
                          <span>
                            {row?.order_item_status === "Assigned" ? (
                              <Button className="!bg-fuchsia-500 !text-[8px] !text-white">
                                Assigned
                              </Button>
                            ) : null}
                          </span> */}
                        </TableCell>
                        <TableCell align="center">
                          {/* <FormControl
                            fullWidth
                            sx={{ minWidth: 80 }}
                            size="small"
                            className="!p-2"
                          >
                            <Select
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              defaultValue={row?.order_item_status}
                              onChange={(event) =>
                                handleUpdate(event.target.value, row?.item_code)
                              }
                            >
                              {row?.orderitem_status === "Delivered"
                                ? null
                                : [
                                    "Pending",
                                    "Accepted",
                                    "Rejected",
                                    "Dispatch",
                                    "Delivered",
                                    "Shipped",
                                    "Cancelled",
                                  ].map((items) => (
                                    <MenuItem value={items}>{items}</MenuItem>
                                  ))}
                            </Select>
                          </FormControl> */}
                          <TableCell
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "font-family: 'Poppins', sans-serif;",
                            }}
                          >
                            {row?.order_item_status === "Delivered" ? (
                              "--"
                            ) : (
                              <FormControl
                                fullWidth
                                sx={{ minWidth: 120 }}
                                size="small"
                              >
                                <Select
                                  labelId="demo-select-small-label"
                                  id="demo-select-small"
                                  value={
                                    row?.order_item_status === "Cancelled"
                                      ? row?.cancel_status
                                      : row?.order_item_status === "Replacement"
                                        ? row?.replacement_status
                                        : row?.order_item_status === "Returned"
                                          ? row?.return_status
                                          : row?.order_item_status
                                  }
                                  defaultValue={row?.order_item_status}
                                  onChange={(event) =>
                                    handleUpdate(
                                      event.target.value,
                                      row?.item_code,
                                    )
                                  }
                                >
                                  {row?.order_item_status === "Cancelled"
                                    ? CANCELSTATUS?.map((item) => (
                                        <MenuItem key={item} value={item}>
                                          {item}
                                        </MenuItem>
                                      ))
                                    : row?.order_item_status === "Replacement"
                                      ? REPLACEMENTSTATUS?.map((item) => (
                                          <MenuItem key={item} value={item}>
                                            {item}
                                          </MenuItem>
                                        ))
                                      : row?.order_item_status === "Returned"
                                        ? RETURNSTATUS?.map((item) => (
                                            <MenuItem key={item} value={item}>
                                              {item}
                                            </MenuItem>
                                          ))
                                        : ORDERITEMSTATUS?.map((item) => (
                                            <MenuItem key={item} value={item}>
                                              {item}
                                            </MenuItem>
                                          ))}
                                </Select>
                              </FormControl>
                            )}
                          </TableCell>
                        </TableCell>

                        <TableCell align="center">
                          {" "}
                          {["Returned", "Replacement"]?.includes(
                            row?.order_item_status,
                          ) ? (
                            <Reason data={row} />
                          ) : (
                            "---"
                          )}
                        </TableCell>
                        <TableCell align="center">{row?.item_code}</TableCell>
                        <TableCell align="center">
                          <CropRotateIcon
                            className="text-green-500 font-bold"
                            // onClick={(event) => allOrderPayment(event, row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="shadow-sm shadow-slate-400 my-3 p-3">
                <div className="flex justify-between py-3">
                  <div>
                    <p className="text-gray-600 text-[14px]">Total Amout</p>
                    <p className="text-gray-600 text-[14px]">Total Tax Amout</p>
                    <p className="text-gray-600 text-[14px]">Discount</p>
                    <p className="text-gray-600 text-[14px]">Delivery Charge</p>
                  </div>
                  <div className="w-30">
                    <p className="text-gray-600 text-[14px]">
                      <span className="text-red-500">₹ </span>{" "}
                      {orderItem[0]?.order?.total_price}
                    </p>
                    <p className="text-gray-600 text-[14px]">
                      <span className="text-red-500">₹ </span>
                      {orderItem[0]?.tax_amount.toFixed(2)}
                    </p>
                    <p className="text-gray-600 text-[14px]">
                      <span className="text-red-500">₹ </span>{" "}
                      {orderItem[0]?.discount_price.toFixed(2)}
                    </p>
                    <p className="text-gray-600 text-[14px]">
                      <span className="text-red-500">₹ </span>{" "}
                      {orderItem[0]?.order?.total_delivery_charge}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="flex justify-between py-2">
                  <div className="text-gray-900 text-[14px]">
                    Total Order Amout
                  </div>
                  <div className="text-green-600 text-[14px] ">
                    ₹ {orderItem[0]?.order?.total_amount.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      </div>
      <div
        className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600"
        style={{ width: "100%" }}
      >
        <div className="flex items-center justify-between my-1">
          <span className="flex items-center gap-2">
            <CustomIconButton size="small">
              <FilterAlt
                sx={{ fontSize: 18 }}
                onClick={handleOpen}
                className="!text-sky-900 text-transparent !bg-white"
              />
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className=""
              >
                <Box
                  sx={style}
                  className="!bg-slate-100 !rounded-2xl !w-96"
                  ref={hideBox}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    <div className="text-center font-bold underline underline-offset-1">
                      Filter{" "}
                    </div>
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {/* <DatePicker label="From Date" value={fromDate} onChange={(event) => setFromDate(event.target.value)} className='!w-[100%]' /><br/> */}
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker label="Basic date picker" />
                      </DemoContainer>
                    </LocalizationProvider> */}
                    FROM DATE :
                    <input
                      type="date"
                      className="w-[100%] rounded h-10 px-2"
                      style={{ border: "1px solid gray" }}
                      onChange={(event) => setFromDate(event.target.value)}
                    />
                    <br />
                    <div className="pt-3">TO DATE :</div>
                    <input
                      type="date"
                      value={toDates}
                      onChange={(event) => setToDates(event.target.value)}
                      className="border border-black w-[100%] h-10 rounded px-2 ms-6"
                    />
                    <br />
                    {/* Order Status <input type='text' placeholder='E' className='border border-black w-[60%] rounded-sm my-3' /><br /> */}
                    <div className="pt-3">STATUS :</div>
                    <select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="!h-10 !text-black !border border-black rounded !w-[100%]"
                      value={selectStatus}
                      onChange={(event) => setSelectStatus(event.target.value)}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Accepted">Accepted</option>
                      <option value="Assigned">Assigned</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Refunded">Refunded</option>
                      <option value="Returned">Returned</option>
                    </select>
                    <br />
                    <br />
                    <div className="justify-between items-center py-4 gap-x-5">
                      <Button
                        variant="contained"
                        color="warning"
                        className="!bg-primary-700 !text-black"
                        onClick={handleClose}
                      >
                        CANCEL
                      </Button>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={handleClose}
                        className="float-right "
                      >
                        Apply
                      </Button>
                    </div>
                  </Typography>
                </Box>
              </Modal>
            </CustomIconButton>
            <input
              type="text"
              value={searchQuery}
              className="!w-56 px-2 rounded-md text-xs"
              placeholder="search"
              style={{ border: "1px solid black", height: 28 }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          {/* {superuserId === "true" ? (
            <span>
              <Autocomplete
                options={options}
                getOptionLabel={(option) => option?.store_name}
                className="!w-72 !mr-3"
                renderOption={(props, option) => (
                  <MenuItem
                    {...props}
                    onClick={() => handleStore(option.store_id)}
                  >
                    {option.store_name}
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="choose a store"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </span>
          ) : null} */}
        </div>
        {/* 
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "71vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ORDER DATE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ORDER ID
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CUSTOMER NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MOBILE
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="!w-24">AMOUNT</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="!w-32">ORDER STATUS</div>
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="!w-32">Order Type</div>
                </TableCell>

                {superuserId === "true" ? (
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="!w-40">ASSIGN TO ANOTHER</div>
                  </TableCell>
                ) : (
                  ""
                )}
                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Details
                </TableCell>
                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Order Details
                </TableCell>

                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Sync To ShipRocket
                </TableCell>

                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Sync To Porter
                </TableCell>

                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Porter Quotation
                </TableCell>

                <TableCell
                  className="!text-center !w-44 !text-gray-800 !font-bold"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Cancel Porter Order
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!max-h-[50vh] !overflow-y-auto">
              {orderData &&
                orderData?.map((row) => (
                  <TableRow className="">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.order_date ? row.order_date.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.orderid_id ? row.orderid_id : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px] !py-[-20px] !my-[-20px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.customer_first_name}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.customer_phone}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      ₹ {row?.total_amount ? row.total_amount : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="flex w-full flex-col gap-2">
                        {row?.itemwise_status?.map((i) => (
                          <span
                            key={i}
                            style={{
                              backgroundColor: STATUS_COLORS[i] || "#000",
                              color: "#fff",
                              padding: "2px 2px",
                              borderRadius: "4px",
                           
                              fontSize: "12px",
                            }}
                          >
                            {i}
                          </span>
                        ))}
                      </div>
                    </TableCell>

                    <TableCell
                      className="!text-center !text-blue-700 "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.is_preorder ? (
                        <Chip size="small" label="PreOrder" color="success" />
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    {superuserId === "true" ? (
                      <TableCell
                        className="!text-center !text-blue-700 "
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
             

                        <Switch
                          onChange={() => handleChange(row?.id)}
                          className="!text-center !text-blue-700"
                          inputProps={{ "aria-label": "controlled" }}
                          size="small"
                        />
                      </TableCell>
                    ) : (
                      ""
                    )}
                    <TableCell
                      className="!text-center "
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      <Popup
                        trigger={
                          <button className="button text-white rounded">
   
                            <Button
                              onClick={handleOpen1}
                              className="!bg-blue-500 !text-[8px] !text-white"
                          
                              style={{ fontFamily: "'Poppins', sans-serif" }}
                            >
                              view
                            </Button>
                          </button>
                        }
                        modal
                      >
                        <div
                          className=" text-black rounded-xl p-4"
                          style={{
                            border: "1px solid gray",
                            background:
                              "linear-gradient(180deg, rgba(2, 0, 40, 1) 0%, rgba(1, 0, 75, 1) 49%, rgba(2, 0, 95, 1) 65%, rgba(2, 0, 120, 1) 100%)",
                          }}
                          ref={box1}
                        >
                          <div
                            className="absolute cursor-pointer right-[-9px] top-[-7px] rounded"
                            onClick={closeModal}
                          >
                            <span className="text-white bg-black rounded-2xl pb-2 p-1">
                              <CloseIcon />
                            </span>
                          </div>
                          <div className="text-center text-lg underline text-red-800 font-bold">
                            All Details{" "}
                          </div>
                          <div className=" text-white mx-auto flex py-2">
                            <div className="ml-10">
                              <p className="w-40 text-[12px] py-1">
                                CUSTOMER NAME :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                {" "}
                                ORDER DATE :
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                ORDER ID :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                STORE NAME :
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                MOBILE :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                AMOUNT :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                STATUS :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1 pt-4">
                                TOTAL PRICE :{" "}
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                SHIPPING CHARGES :
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                DISCOUNT:
                              </p>
                              <p className="w-40 text-sm text-[12px] py-1">
                                DUE AMOUNT:
                              </p>
                            </div>
                            <div
                              className=""
                              style={{ borderRight: "1px solid gray" }}
                            >
                              <div className="w-48 text-sm text-[12px] py-1 ">
                                {row?.customer_first_name
                                  ? row?.customer_first_name
                                  : "--"}
                                <span>
                                  {" "}
                                  {row?.customer_last_name
                                    ? row?.customer_last_name
                                    : "--"}
                                </span>
                              </div>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.order_date
                                  ? row.order_date.slice(1, 10)
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.orderid_id ? row.orderid_id : "--"}
                              </p>
                              <p className="w-48 text-sm  py-1">
                                {row?.store?.store_name}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.customer_phone}
                              </p>
                              <p className="w-48  text-sm text-[12px]  py-1">
                                {row?.total_amount ? row.total_amount : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                <span>
                                  {row?.order_status === "Delivered" ? (
                                    <Button
                                      size="small"
                                      className="!bg-green-400 text-sm text-[12px]  !text-white"
                                    >
                                      Delivered
                                    </Button>
                                  ) : null}
                                </span>
                                <span>
                                  {row?.order_status === "Pending" ? (
                                    <Button
                                      size="small"
                                      className="!bg-pink-500 text-sm text-[12px]  !text-white"
                                    >
                                      Pending
                                    </Button>
                                  ) : null}
                                </span>
                                <span>
                                  {row?.order_status === "Order Placed" ? (
                                    <Button
                                      size="small"
                                      className="!bg-yellow-400 text-sm text-[12px]  !text-white"
                                    >
                                      Order Placed
                                    </Button>
                                  ) : null}
                                </span>
                                <span>
                                  {row?.order_status === "Shipped" ? (
                                    <Button
                                      size="small"
                                      className="!bg-purple-400 text-sm text-[12px]  !text-white"
                                    >
                                      Shipped
                                    </Button>
                                  ) : null}
                                </span>
                                <span>
                                  {row?.order_status === "Drafts" ? (
                                    <Button
                                      size="small"
                                      className="!bg-red-600 text-sm text-[12px]  !text-white"
                                    >
                                      Drafts
                                    </Button>
                                  ) : null}
                                </span>
                                <span>
                                  {row?.order_status === "Rejected" ? (
                                    <Button
                                      size="small"
                                      className="!bg-violet-500 text-sm text-[12px]  !text-white"
                                    >
                                      Rejected
                                    </Button>
                                  ) : null}
                                </span>
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.total_price}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.shipping_charges}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.total_discount
                                  ? row?.total_discount
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.due_amount ? row?.due_amount : "--"}
                              </p>
                            </div>
                            <div className="" style={{ paddingLeft: "15px" }}>
                              <p className="py-1 text-sm text-[12px]   w-40">
                                STORE ADDRESS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                {" "}
                                COUNTRY :
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                {" "}
                                EMAIL :
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                STATE :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                CITY :
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                PINCODE :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                BANK NAME :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                ACCOUNT NO :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                CURRENT BALENCE :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                PAN NUMBER :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                SIGNATURE :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px]  w-40">
                                SWIFT CODE :{" "}
                              </p>
                            </div>
                            <div
                              className=""
                              style={{ borderRight: "1px solid gray" }}
                            >
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.store?.store_address
                                  ? row?.store?.store_address
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.customer_country
                                  ? row?.customer_country
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.customer_email
                                  ? row?.customer_email
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.customer_state
                                  ? row?.customer_state
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.customer_city ? row?.customer_city : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.store?.pincode
                                  ? row?.store?.pincode
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px]  py-1">
                                {row?.store?.bank_name
                                  ? row?.store?.bank_name
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.store?.account_no
                                  ? row?.store?.account_no
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.store?.current_balance
                                  ? row?.store?.current_balance
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.store?.pan_number
                                  ? row?.store?.pan_number
                                  : "--"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.store?.signature ? "YES" : "NO"}
                              </p>
                              <p className="w-48 text-sm text-[12px] py-1">
                                {row?.store?.swift_code
                                  ? row?.store?.swift_code
                                  : "--"}
                              </p>
                            </div>
                            <div className="" style={{ paddingLeft: "15px" }}>
                              <p className="py-1 text-sm text-[12px] w-40">
                                CUSTOMER STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                {" "}
                                DELIVERY MANAGE BY :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                MANUFACTURING STATEUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                CURRENCY :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                REAL TIME SYNCE :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                TEAM STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                LEAD STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                {" "}
                                VARIANT STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                SPEC STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                SYNC STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-40">
                                BULK PRODUCT STATUS :{" "}
                              </p>
                              <p className="py-1 text-sm text-[12px] w-44">
                                HIRING HISTORY STATUS :{" "}
                              </p>
                            </div>
                            <div className="">
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.customer_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.delivery_manages_by
                                  ? row?.store?.delivery_manages_by
                                  : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.manufacturing_status
                                  ? row?.store?.manufacturing_status
                                  : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.currency ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.is_real_time_sync ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.team_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.leads_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.variant_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.spec_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.sync_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.bulk_product_status ? "yes" : "no"}
                              </p>
                              <p className="w-20 text-sm text-[12px] py-1">
                                {row?.store?.hiring_history_status
                                  ? "yes"
                                  : "no"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Popup>
                    </TableCell>
                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => sideBarDataList(row?.id)}
                      >
                        Show
                      </Button>
                    </TableCell>

                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        variant="contained"
                        color={
                          row?.sync_to_shiprocket ? "success" : "secondary"
                        }
                        size="small"
                        onClick={() => {
                          if (
                            !row?.sync_to_shiprocket &&
                            !row?.sync_to_porter
                          ) {
                            SyncData(row?.id);
                          } else {
                            toast.warn(
                              `This item has already been synced via ${row?.sync_to_shiprocket ? "Ship Rocket" : "Porter"}.`,
                            );
                          }
                        }}
                      >
                        Sync
                      </Button>
                    </TableCell>
                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        variant="contained"
                        color={row?.sync_to_porter ? "success" : "secondary"}
                        size="small"
                        onClick={() => {
                          if (
                            !row?.sync_to_shiprocket &&
                            !row?.sync_to_porter
                          ) {
                            PorterSyncData(row?.id);
                          } else {
                            toast.warn(
                              `This item has already been synced via ${row?.sync_to_shiprocket ? "Ship Rocket" : "Porter"}.`,
                            );
                          }
                        }}
                      >
                        Sync
                      </Button>
                    </TableCell>

                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#3B82F6",
                        }}
                        size="small"
                        onClick={() =>
                          ViewPricing({
                            pickup_lat: row?.admin_latitude,
                            pickup_lng: row?.admin_longitude,
                            drop_lat: row?.address_latitude,
                            drop_lng: row?.address_longitude,
                          })
                        }
                      >
                        view
                      </Button>
                    </TableCell>

                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#FF0000",
                        }}
                        size="small"
                        disabled={Boolean(
                          !row?.sync_to_porter ||
                          row?.order_status === "Delivered",
                        )}
                        onClick={() => CancelPorterOrder(row?.porter_order_id)}
                      >
                        Cancel Order
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer> */}

        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "74vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={headSx}>ORDER DATE</TableCell>
                <TableCell sx={headSx}>ORDER ID</TableCell>
                <TableCell sx={headSx}>CUSTOMER NAME</TableCell>
                <TableCell sx={headSx}>MOBILE</TableCell>
                <TableCell sx={headSx}>AMOUNT</TableCell>
                <TableCell sx={headSx}>ORDER STATUS</TableCell>
                <TableCell sx={headSx}>ORDER TYPE</TableCell>
                {superuserId === "true" ? (
                  <TableCell sx={headSx}>ASSIGN TO ANOTHER</TableCell>
                ) : (
                  ""
                )}
                <TableCell sx={headSx}>DETAILS</TableCell>
                <TableCell sx={headSx}>ORDER DETAILS</TableCell>
                <TableCell sx={headSx}>SYNC TO SHIPROCKET</TableCell>
                <TableCell sx={headSx}>SYNC TO PORTER</TableCell>
                <TableCell sx={headSx}>PORTER QUOTATION</TableCell>
                <TableCell sx={{ ...headSx, borderRight: "none" }}>
                  CANCEL PORTER ORDER
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {orderData &&
                orderData?.map((row) => (
                  <TableRow key={row?.id} hover>
                    <TableCell sx={cellSx}>
                      {row?.order_date ? row.order_date.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.orderid_id ? row.orderid_id : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.customer_first_name}
                    </TableCell>
                    <TableCell sx={cellSx}>{row?.customer_phone}</TableCell>
                    <TableCell sx={cellSx}>
                      ₹ {row?.total_amount ? row.total_amount : "--"}
                    </TableCell>

                    <TableCell sx={cellSx}>
                      <div className="flex w-full flex-col items-center gap-0.5">
                        {row?.itemwise_status?.map((i, idx) => (
                          <span
                            key={idx}
                            style={statusChipStyle(STATUS_COLORS[i])}
                          >
                            {i}
                          </span>
                        ))}
                      </div>
                    </TableCell>

                    <TableCell sx={cellSx}>
                      {row?.is_preorder ? (
                        <Chip
                          size="small"
                          label="PreOrder"
                          color="success"
                          sx={{ height: 18, fontSize: "10px" }}
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    {superuserId === "true" ? (
                      <TableCell sx={cellSx}>
                        <Switch
                          onChange={() => handleChange(row?.id)}
                          inputProps={{ "aria-label": "controlled" }}
                          size="small"
                        />
                      </TableCell>
                    ) : (
                      ""
                    )}

                    <TableCell sx={cellSx}>
                      <Popup
                        trigger={
                          <button className="button text-white rounded">
                            <Button
                              onClick={handleOpen1}
                              className="!bg-blue-500 !text-white"
                              size="small"
                              sx={btnSx}
                              style={{ fontFamily: "'Poppins', sans-serif" }}
                            >
                              view
                            </Button>
                          </button>
                        }
                        modal
                      >
                        {/* yaha tumhara poora purana popup content
                    (<div ref={box1}> ... All Details ... </div>) same rakho */}
                      </Popup>
                    </TableCell>

                    <TableCell sx={cellSx}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={btnSx}
                        onClick={() => sideBarDataList(row?.id)}
                      >
                        Show
                      </Button>
                    </TableCell>

                    <TableCell sx={cellSx}>
                      <Button
                        variant="contained"
                        color={
                          row?.sync_to_shiprocket ? "success" : "secondary"
                        }
                        size="small"
                        sx={btnSx}
                        onClick={() => {
                          if (
                            !row?.sync_to_shiprocket &&
                            !row?.sync_to_porter
                          ) {
                            SyncData(row?.id);
                          } else {
                            toast.warn(
                              `This item has already been synced via ${row?.sync_to_shiprocket ? "Ship Rocket" : "Porter"}.`,
                            );
                          }
                        }}
                      >
                        Sync
                      </Button>
                    </TableCell>

                    <TableCell sx={cellSx}>
                      <Button
                        variant="contained"
                        color={row?.sync_to_porter ? "success" : "secondary"}
                        size="small"
                        sx={btnSx}
                        onClick={() => {
                          if (
                            !row?.sync_to_shiprocket &&
                            !row?.sync_to_porter
                          ) {
                            PorterSyncData(row?.id);
                          } else {
                            toast.warn(
                              `This item has already been synced via ${row?.sync_to_shiprocket ? "Ship Rocket" : "Porter"}.`,
                            );
                          }
                        }}
                      >
                        Sync
                      </Button>
                    </TableCell>

                    <TableCell sx={cellSx}>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ ...btnSx, backgroundColor: "#3B82F6" }}
                        onClick={() =>
                          ViewPricing({
                            pickup_lat: row?.admin_latitude,
                            pickup_lng: row?.admin_longitude,
                            drop_lat: row?.address_latitude,
                            drop_lng: row?.address_longitude,
                          })
                        }
                      >
                        view
                      </Button>
                    </TableCell>

                    <TableCell sx={{ ...cellSx, borderRight: "none" }}>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ ...btnSx, backgroundColor: "#FF0000" }}
                        disabled={Boolean(
                          !row?.sync_to_porter ||
                          row?.order_status === "Delivered",
                        )}
                        onClick={() => CancelPorterOrder(row?.porter_order_id)}
                      >
                        Cancel Order
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPage !== 0 && (
          <div className="flex justify-center p-2">
            <Pagination
              page={currentPage}
              size="small"
              count={totalPage}
              variant="outlined"
              color="primary"
              onChange={handleChange1}
            />
          </div>
        )}

        <Dialog
          open={pricingModalOpen}
          onClose={() => {
            setPricingModalOpen(false);
            setVehicleData([]);
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle className="!font-bold !text-xl">
            🚚 Vehicle Pricing & Details
          </DialogTitle>
          <DialogContent dividers>
            {pricingLoading
              ? [...Array(3)].map((_, idx) => (
                  <Box
                    key={idx}
                    className="mb-5 p-4 rounded-xl border border-gray-300 shadow-sm bg-gray-50"
                  >
                    <Skeleton
                      variant="text"
                      width="40%"
                      height={30}
                      className="mb-2"
                    />
                    <Grid container spacing={2}>
                      {[...Array(6)].map((__, i) => (
                        <Grid item xs={12} md={6} key={i}>
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={30}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                ))
              : vehicleData?.map((vehicle, index) => (
                  <Box
                    key={index}
                    className="mb-5 p-4 rounded-xl border border-gray-300 shadow-sm bg-gray-50 hover:shadow-md transition-all"
                  >
                    <Typography
                      variant="h6"
                      className="!text-blue-700 font-semibold flex items-center gap-2 mb-2"
                    >
                      <DirectionsCar fontSize="small" /> {vehicle.type}
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <Scale fontSize="small" className="text-green-700" />
                          <strong>Capacity:</strong> {vehicle.capacity.value}{" "}
                          {vehicle.capacity.unit}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <MonetizationOn
                            fontSize="small"
                            className="text-yellow-600"
                          />
                          <strong>Fare:</strong> ₹
                          {(vehicle.fare.minor_amount / 100).toFixed(2)}{" "}
                          {vehicle.fare.currency}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <Straighten
                            fontSize="small"
                            className="text-purple-600"
                          />
                          <strong>Length:</strong> {vehicle.size.length.value}{" "}
                          {vehicle.size.length.unit}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <Straighten
                            fontSize="small"
                            className="text-purple-600 rotate-90"
                          />
                          <strong>Breadth:</strong> {vehicle.size.breadth.value}{" "}
                          {vehicle.size.breadth.unit}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <Straighten
                            fontSize="small"
                            className="text-purple-600 rotate-45"
                          />
                          <strong>Height:</strong> {vehicle.size.height.value}{" "}
                          {vehicle.size.height.unit}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className="flex gap-2 items-center">
                          <strong>ETA:</strong>
                          <Chip
                            label={vehicle.eta ? vehicle.eta : "N/A"}
                            color={vehicle.eta ? "success" : "default"}
                            size="small"
                          />
                        </Box>
                      </Grid>
                    </Grid>

                    {index !== vehicleData.length - 1 && (
                      <Divider className="mt-4" />
                    )}
                  </Box>
                ))}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setPricingModalOpen(false);
                setVehicleData([]);
              }}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default OrderManagement;
